import { render } from "./PCUltimosVolcados.vue?vue&type=template&id=711a4552&scoped=true"
import script from "./PCUltimosVolcados.vue?vue&type=script&lang=js"
export * from "./PCUltimosVolcados.vue?vue&type=script&lang=js"

import "./PCUltimosVolcados.vue?vue&type=style&index=0&id=711a4552&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711a4552"]])

export default __exports__